import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import editIcon from '../../../../../assets/editProfile.svg'
import { useIsMobile } from '../../../../../hooks/useIsMobile'
import { useIsTablet } from '../../../../../hooks/useIsTablet'
import {
  FollowAction,
  unFollowAction
} from '../../../../../redux/actions/FollowingActions'
import ProfileInfo from '../ProfileInfo'
import {
  AvatarAccessory,
  AvatarContainer,
  BasicUserInfoContainer,
  Container,
  Content,
  Description,
  EditAvatarButton,
  EditProfileButton,
  FollowButton,
  LeftProfileInfoPart,
  LevelPlank,
  MobileAvatar,
  MobileAvatarWrapper,
  Username
} from './Sidebar.styles'
import { getUserAvatar } from '../../../../../utils/getUserAvatar'

const DMProfilePic = dynamic(
  () =>
    import('@decormatters/dm-theme').then(component => component.DMProfilePic),
  { ssr: false }
)

const Sidebar = ({
  isOthers = false,
  openCoinsHistory,
  setAvatarModalOpened
}) => {
  const isTablet = useIsTablet()
  const isMobile = useIsMobile()
  const { me } = useSelector(state => state.profile)
  const { others } = useSelector(state => state.profile)
  const { following } = useSelector(state => state.follows)
  const router = useRouter()

  const dispatch = useDispatch()

  let id = others && others.objectId
  const handleFollowClick = () => {
    if (followed) return dispatch(unFollowAction(id))

    dispatch(FollowAction(id))
  }

  const handleEdit = () => {
    router.push('/settings')
  }

  let followed = following.includes(id)

  let followedStyle = {
    color: '#8B8B8B',
    backgroundColor: '#EDEDED',
    borderColor: '#EDEDED'
  }

  const user = isOthers ? others : me

  const profileDescription = user && user?.aboutMe?.trim()

  return (
    <>
      <Container>
        <Content>
          {isMobile && (
            <LeftProfileInfoPart>
              <MobileAvatarWrapper>
                <MobileAvatar src={getUserAvatar(user)} alt="" />
                <LevelPlank>L{Math.floor(user?.userLevel || 0)}</LevelPlank>
                {user?.funAccessoriesImageUrl && (
                  <AvatarAccessory
                    alt=""
                    src={user.funAccessoriesImageUrl}
                    loading="lazy"
                  />
                )}
                {isOthers || (
                  <EditAvatarButton onClick={setAvatarModalOpened}>
                    <img src={editIcon} />
                  </EditAvatarButton>
                )}
              </MobileAvatarWrapper>
              <BasicUserInfoContainer>
                <Username>{user && user.uniqueDisplayName}</Username>
                {profileDescription && (
                  <Description>{profileDescription}</Description>
                )}
                {isOthers && (
                  <FollowButton
                    onClick={handleFollowClick}
                    style={followed ? followedStyle : null}
                  >
                    {followed ? 'Followed' : 'Follow'}
                  </FollowButton>
                )}
                {!isOthers && (
                  <EditProfileButton onClick={handleEdit}>
                    Edit Profile
                  </EditProfileButton>
                )}
              </BasicUserInfoContainer>
            </LeftProfileInfoPart>
          )}
          {!isMobile && (
            <>
              <LeftProfileInfoPart>
                <AvatarContainer
                  onClick={isOthers ? null : setAvatarModalOpened}
                >
                  <DMProfilePic
                    showLevelBar={!isOthers}
                    autoPlay
                    startLevel={(user && user.userLevel) || 0}
                    endLevel={(user && user.userLevel) || 0}
                    level={(user && user.userLevel) || 0}
                    pic={getUserAvatar(user)}
                  />
                  {user?.funAccessoriesImageUrl && (
                    <AvatarAccessory
                      alt=""
                      src={user.funAccessoriesImageUrl}
                      loading="lazy"
                    />
                  )}
                  {isOthers || (
                    <EditAvatarButton onClick={setAvatarModalOpened}>
                      <img src={editIcon} />
                    </EditAvatarButton>
                  )}
                </AvatarContainer>
                <BasicUserInfoContainer>
                  <Username>{user && user.uniqueDisplayName}</Username>
                  {user && user.aboutMe && (
                    <Description>{user.aboutMe}</Description>
                  )}
                </BasicUserInfoContainer>
              </LeftProfileInfoPart>
              {isOthers && (
                <FollowButton
                  onClick={handleFollowClick}
                  style={followed ? followedStyle : null}
                >
                  {followed ? 'Followed' : 'Follow'}
                </FollowButton>
              )}
              {!isOthers && (
                <EditProfileButton onClick={handleEdit}>
                  Edit Profile
                </EditProfileButton>
              )}
            </>
          )}
          {!isTablet && !isMobile && (
            <ProfileInfo
              isOthers={isOthers}
              openCoinsHistory={openCoinsHistory}
            />
          )}
        </Content>
      </Container>
    </>
  )
}

export default Sidebar
